import React from "react";

function CloudIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0996 10.8984V21.7984L33.5996 16.2984L24.0996 10.8984Z"
        fill="#00D3A9"
      />
      <path
        d="M24.0996 24.1016V35.1016L33.5996 29.6016L24.0996 24.1016Z"
        fill="#00D3A9"
      />
      <path d="M22.7004 21.8V11L13.4004 16.4L22.7004 21.8Z" fill="#00B39F" />
      <path
        d="M3.90039 35.0984C5.70039 38.0984 8.20039 40.5984 11.2004 42.3984V30.8984L3.90039 35.0984Z"
        fill="#00B39F"
      />
      <path
        d="M22.7008 35.1031V24.2031L13.3008 29.6031L22.7008 35.1031Z"
        fill="#00B39F"
      />
      <path
        d="M12.5996 41.7047L22.0996 36.3047L12.5996 30.8047V41.7047Z"
        fill="#00D3A9"
      />
      <path
        d="M34.3008 41.7047V30.8047L24.8008 36.3047L34.3008 41.7047Z"
        fill="#00B39F"
      />
      <path
        d="M43.6004 33.8C45.2004 30.9 46.1004 27.5 46.3004 24L36.4004 29.7L43.6004 33.8Z"
        fill="#00B39F"
      />
      <path
        d="M35.6992 28.5016L45.1992 23.0016L35.6992 17.6016V28.5016Z"
        fill="#00D3A9"
      />
      <path
        d="M34.3004 15.1984V4.39844L24.9004 9.79844L34.3004 15.1984Z"
        fill="#00B39F"
      />
      <path d="M34.3008 28.4V17.5L24.8008 23L34.3008 28.4Z" fill="#00B39F" />
      <path d="M12.5996 17.5V28.5L22.0996 23L12.5996 17.5Z" fill="#00D3A9" />
      <path
        d="M22.6992 0.101562C19.0992 0.201563 15.6992 1.20156 12.6992 2.80156L22.6992 8.60156V0.101562Z"
        fill="#00B39F"
      />
      <path
        d="M12.5996 4.30469V15.2047L22.0996 9.80469L12.5996 4.30469Z"
        fill="#00D3A9"
      />
      <path
        d="M11.2004 3.60156C8.30039 5.50156 5.80039 8.00156 3.90039 10.9016L11.2004 15.1016V3.60156Z"
        fill="#00B39F"
      />
      <path
        d="M34.1996 2.80156C31.1996 1.20156 27.6996 0.201563 24.0996 0.101562V8.60156L34.1996 2.80156Z"
        fill="#00D3A9"
      />
      <path
        d="M0.5 23.8047C0.6 27.4047 1.6 30.9047 3.2 33.9047L10.6 29.6047L0.5 23.8047Z"
        fill="#00D3A9"
      />
      <path
        d="M3.29961 12.1016C1.69961 15.1016 0.699609 18.5016 0.599609 22.1016L10.6996 16.3016L3.29961 12.1016Z"
        fill="#00D3A9"
      />
      <path
        d="M12.6992 43.2C15.6992 44.8 19.0992 45.8 22.7992 45.9V37.5L12.6992 43.2Z"
        fill="#00B39F"
      />
      <path
        d="M42.8992 11.0031C41.0992 8.10313 38.5992 5.60312 35.6992 3.70312V15.2031L42.8992 11.0031Z"
        fill="#00D3A9"
      />
      <path
        d="M35.6992 42.3031C38.5992 40.4031 41.0992 37.9031 42.8992 34.9031L35.6992 30.7031V42.3031Z"
        fill="#00D3A9"
      />
      <path
        d="M46.3008 22.1016C46.2008 18.5016 45.2008 15.1016 43.6008 12.1016L36.3008 16.3016L46.3008 22.1016Z"
        fill="#00B39F"
      />
      <path
        d="M24.0996 45.8984C27.6996 45.7984 31.0996 44.7984 34.0996 43.1984L24.0996 37.3984V45.8984Z"
        fill="#00D3A9"
      />
      <path
        d="M11.2008 28.4016V17.6016L1.80078 23.0016L11.2008 28.4016Z"
        fill="#00B39F"
      />
    </svg>
  );
}

export default CloudIcon;
